import { useState, useEffect } from "react";

import api from './common/services/liferay/api.js';
import { Search } from './common/components/Search.jsx';

export const App = ({ minuteInterval, minHour, maxHour, layout, airportCode }) => {

    const [isAirport, setIsAirport] = useState(true);
    const [terminals, setTerminals] = useState([]);
    const [airportTerminals, setAirportTerminals] = useState([]);

    const getTerminals = async () => {
            let usedFilteredAirports = true;
            const airportTerminals = [];
            const siteId = Liferay.ThemeDisplay.getScopeGroupId();

            // let airportResponse = await api(`o/c/aeropuertos/?filter=siteId eq '${siteId}'`)
            //     .then(response => response.json());

             let airportResponse = await api(`o/c/aeropuertos/?filter=codigoAeropuerto eq '${airportCode}'`)
                .then(response => response.json());

            if (!airportResponse?.items.length) {
                usedFilteredAirports = false;
                setIsAirport(false)

                airportResponse = await api(`o/c/aeropuertos/`)
                    .then(response => response.json());
            }

            const airportList = airportResponse?.items || [];
            const terminalsData = await Promise.all(
                airportList.map(async (airport) => {
                    // const terminalsResponse = await api(`o/c/terminals/?filter=r_aeropuertoTerminales_c_aeropuertoId eq '${airport.id}'`)
                    //     .then(res => res.json());

                        const terminalsResponse = await api(`o/c/aeropuertos/${airport.id}/aeropuertoTerminales`)
                        .then(res => res.json());

                    const terminals = terminalsResponse?.items || [];

                    if (terminals.length === 1 && usedFilteredAirports) {
                        return [{
                            codigoAeropuerto: airport.codigoAeropuerto,
                            aeropuertoNombre: airport.nombre,
                            terminalNombre: terminals[0].nombre.slice(-2),
                            label: airport.nombre
                        }];
                    }

                    return terminals.map(terminal => ({
                        codigoAeropuerto: airport.codigoAeropuerto,
                        aeropuertoNombre: airport.nombre,
                        terminalNombre: terminal.nombre.slice(-2),
                        label: usedFilteredAirports
                            ? terminal.nombre.slice(-2)
                            : `${airport.nombre} ${terminal.nombre.slice(-2)} (${airport.codigoAeropuerto})`
                    }));
                }));
            setAirportTerminals(terminalsData.flat());
        };

    useEffect(() => {
        getTerminals();
    }, []);

    return (
        <>
            {<Search
                minuteInterval={minuteInterval}
                minHour={minHour}
                maxHour={maxHour}
                layout={layout}
                isAirport={isAirport}
                airportTerminals={airportTerminals}
            />}
        </>
    );
};